export default __webpack_public_path__ + "static/media/grafema_illustrations-ua-campaign_03.906796f2.jpg";